<template>
  <div class="product-page">
    <div class="product-header">
      <h1>{{ product.title }}</h1>
    </div>

    <div class="product-main">
      <div class="product-gallery">
        <swiper :loop="true" :spaceBetween="10" :navigation="true" :thumbs="{ swiper: thumbsSwiper }" :modules="modules"
          class="main-swiper">
          <swiper-slide v-for="img in product.attachments" :key="img.id">
            <image-wrap :image="img" size="large" />
          </swiper-slide>
        </swiper>

        <swiper @swiper="setThumbsSwiper" :loop="true" :spaceBetween="10" :slidesPerView="4" :freeMode="true"
          :watchSlidesProgress="true" :modules="modules" class="thumbs-swiper">
          <swiper-slide v-for="img in product.attachments" :key="img.id">
            <image-wrap :image="img" size="small" />
          </swiper-slide>
        </swiper>
      </div>

      <div class="product-details">
        <div class="detail-row">
          <span class="label">Артикул:</span>
          <span>{{ product.sku }}</span>
        </div>

        <div class="detail-row">
          <span class="label">Цена от:</span>
          <div class="price">
            <span class="old">₽{{ product.regular_price }}</span>
            <span class="new">₽{{ product.price }}</span>
          </div>
        </div>

        <div class="product-description" v-html="product.content"></div>

        <div class="features">
          <div class="feature"><i class="fas fa-truck"></i> Доставка по договоренности</div>
          <div class="feature"><i class="fas fa-medal"></i> Гарантия 10 лет</div>
          <div class="feature"><i class="fas fa-hand-holding-usd"></i> Нашли дешевле? Договоримся!</div>
          <div class="feature"><i class="fas fa-shipping-fast"></i> Доставка по всей России</div>
        </div>

        <order-popup-btn :product="product" />

        <div class="contact-buttons">
          <a :href="'tel:' + settings.phone_number"><i class="fas fa-phone"></i>Номер телефона</a>
          <a :href="settings.whats_app"><i class="fab fa-whatsapp"></i>WhatsApp</a>
          <a :href="'tel:' + settings.phone_number"><i class="fab fa-telegram-plane"></i>Telegram</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'
import { FreeMode, Navigation, Thumbs } from 'swiper/modules'

const props = defineProps(['product'])
const settings = ref(_configs.settings)
const thumbsSwiper = ref(null)
const setThumbsSwiper = (swiper) => (thumbsSwiper.value = swiper)
const modules = [FreeMode, Navigation, Thumbs]
</script>
<style scoped>
::v-deep(.swiper-button-next),
::v-deep(.swiper-button-prev) {
  background: #2c3e50;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  color: #FFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: background 0.3s ease;
}

::v-deep(.swiper-button-next:hover),
::v-deep(.swiper-button-prev:hover) {
  background: #2c3e50;
}



.product-page {
  font-family: 'Inter', sans-serif;
  color: #2c3e50;
  padding: 32px;
  max-width: 1400px;
  margin: auto;
  box-sizing: border-box;
  margin-top: 100px;
}

.product-page {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  position: relative;
}

.product-header {
  text-align: center;
  background: linear-gradient(135deg, #3c5757, #2d3f3f);
  color: #fff;
  padding: 24px;
  border-radius: 16px;
  margin-bottom: 32px;
}

.product-header h1 {
  font-size: 32px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.product-main {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
}

.product-gallery,
.product-details {
  flex: 1 1 100%;
  min-width: 280px;
  box-sizing: border-box;
}

@media (min-width: 768px) {

  .product-gallery,
  .product-details {
    flex: 1 1 45%;
  }
}

.main-swiper,
.thumbs-swiper {
  border-radius: 12px;
  margin-bottom: 10px;
  overflow: hidden;
  width: 100%;
}

.main-swiper {
  aspect-ratio: 1 / 1;
}

.thumbs-swiper {
  margin-top: 10px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

@media (max-width: 768px) {
  .detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}

.label {
  font-weight: 600;
  color: #555;
}

.price {
  display: flex;
  gap: 12px;
  align-items: center;
}

@media (max-width: 768px) {
  .price {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}

.old {
  text-decoration: line-through;
  color: black;
}

.new {
  color: #e53935;
  font-size: 20px;
  font-weight: 700;
}

.product-description {
  font-size: 15px;
  color: #444;
  line-height: 1.6;
}

.features {
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 16px;
  margin-top: 10px;
}

.features .feature {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #333;
}

.features i {
  font-size: 22px;
  color: #e8cc0f;
}

.contact-buttons {
  display: flex;
  gap: 16px;
  margin-top: 24px;
  flex-wrap: wrap;
}

.contact-buttons a {
  background: #fff;
  padding: 12px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  color: #3c5757;
  transition: 0.3s;
  font-size: 20px;
  text-align: center;
  flex: 1 1 30%;
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
}

.contact-buttons a:hover {
  background-color: #e8cc0f;
  color: #3c5757;
}

@media screen and (max-width: 480px) {
  .product-header h1 {
    font-size: 22px;
  }

  .contact-buttons a {
    flex: 1 1 45%;
    font-size: 18px;
    padding: 14px;
  }
}
</style>
<style>
.swiper-button-prev:after,
.swiper-rtl .swiper-button-next:after {
  font-size: 20px;
}

.swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after {
  font-size: 20px;
}
</style>
